import React from 'react';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import {
  fontWeightClass,
  getInputClass,
} from '~/assets/styles/classes/InputClasses';

type SliderFieldProps = {
  id: string;
  label?: string;
  required?: boolean;
  fontWeight?: "bold" | "normal" | "extrabold";
  errorLabel?: string;
  disabled?: boolean;
  hideLabel?: boolean;
  borderClass?:
    | "rounded-none"
    | "rounded-sm"
    | "rounded"
    | "rounded-md"
    | "rounded-lg"
    | "rounded-xl"
    | "rounded-2xl"
    | "rounded-3xl";
  readOnly?: boolean;
  onClick?: () => void;
  autoFocus?: boolean;
  min?: number;
  max?: number;
  step?: number;
  value: number;
  valueLabel:string
  onChange: (value: number) => void;
};

export const SliderField: React.FC<SliderFieldProps> = ({
  id,
  label = "Slider",
  required = false,
  fontWeight = "normal",
  errorLabel,
  disabled = false,
  hideLabel = false,
  borderClass = "rounded-lg",
  readOnly = false,
  onClick,
  autoFocus = false,
  min = 0,
  max = 8,
  step = 1,
  value,
  valueLabel,
  onChange,
}) => {
  return (
    <div>
      {!hideLabel && (
        <label
          htmlFor={id}
          className={`inline-block cursor-pointer text-sm ${fontWeightClass(fontWeight)} ${errorLabel ? "text-error" : ""}`}
        >
          {required && <span className="text-red-500">*</span>} {label}
        </label>
      )}

      <div className="relative flex flex-col gap-2 mt-1">
        <input
          type="range"
          id={id}
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          onClick={onClick}
          autoFocus={autoFocus}
          readOnly={readOnly}
          disabled={disabled}
          className={`${getInputClass(borderClass, errorLabel, readOnly)} w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer`}
        />
        <div className="text-sm">
          {valueLabel}: <strong>{value}</strong>
        </div>
      </div>

      {errorLabel && (
        <div className="flex items-center gap-1 mt-1 text-error">
          <HighlightOffRoundedIcon fontSize="small" />
          <span className="text-sm leading-[18px]">{errorLabel}</span>
        </div>
      )}
    </div>
  );
};
